export const whitelistedStatusCodes = [400, 409, 422];
export const acceptedTaxFileTypes = [
  'image/png',
  'image/jpeg',
  'application/pdf',
];
export const allowedTotalTaxFileSizeInBytes = 10000000;
export const gstValidationUrl =
  'https://api.e-waybill.in/api/gstin/validate?gstin=';

export const domainName = '.getOS1.com';
export const urlTooltip =
  'This URL is used to access our solution and by default it\'s your company name. It excludes special characters other than hyphens "-". This cannot be changed later.';

export const SIGN_UP_ORG_DETAIL_FORM = 'customer_sign_up_org_form_data';
export const SIGN_UP_STEP = 'customer_sign_up_step';
export const SIGN_UP_COUNTRY = 'customer_sign_up_country';
export const SIGN_UP_BILLING_DETAIL_FORM = 'customer_sign_up_billing_form_data';
export const SIGN_UP_TAX_ID = 'customer_sign_up_tax_form_data';
export const SIGN_UP_EMAIL_VERIFIED = 'customer_sign_up_is_email_verified';
export const SIGN_UP_ORG_VALID = 'customer_sign_up_org_is_valid';
export const SIGN_UP_BILLING_VALID = 'customer_sign_up_billing_is_valid';
export const SIGN_UP_TAX_TYPE = 'customer_sign_up_tax_type';
export const SIGN_UP_SELECTED_TIER = 'customer_sign_up_selected_tier';
export const SIGN_UP_SELECTED_SOLUTION = 'customer_sign_up_selected_solution';
export const SIGN_UP_FORM_ID = 'customer_sign_up_form_id';
export const SIGN_UP_ADD_ON_FORM = 'customer_sign_up_add_on_form';
export const SIGN_UP_USER_EMAIL = 'custoemr_sign_up_user_email';
export const SIGN_UP_SELECT_PLAN_FORM = 'customer_sign_up_select_plan_form';
export const SIGN_UP_SELECTED_PRODUCT_FAMILY =
  'customer_sign_up_selected_product_family';
export const SIGN_UP_SELECTED_SOLUTION_TYPE =
  'customer_sign_up_selected_solution_type';
export const SIGN_UP_SELECTED_TYPE = 'customer_sign_up_selected_type';

export const GST_STATE = {
  '02': 'HP',
  '03': 'PB',
  '04': 'CH',
  '05': 'UT',
  '06': 'HR',
  '07': 'DL',
  '08': 'RJ',
  '09': 'UP',
  '10': 'BR',
  '11': 'SK',
  '12': 'AP',
  '13': 'NL',
  '14': 'MN',
  '15': 'MZ',
  '16': 'TR',
  '17': 'ML',
  '18': 'AS',
  '19': 'WB',
  '20': 'JH',
  '21': 'OR',
  '22': 'CT',
  '23': 'MP',
  '24': 'GJ',
  '26': 'DH',
  '27': 'MH',
  '28': 'AP',
  '29': 'KA',
  '30': 'GA',
  '31': 'LD',
  '32': 'KL',
  '33': 'TN',
  '34': 'PY',
  '35': 'AN',
  '36': 'TG',
  '37': 'AP',
  '38': 'LA',
  //'97': '0T', not sure what to do with 97
};
